var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Card } from "@mui/material";
import moment from "moment";
import PropTypes from "prop-types";
import { useState } from "react";
import { CustomSkipDaysDateCalendar } from "../../Shared/components/DateTimePickers/CustomSkipDayDateCalendar";
import SkipDaysWarningModal from "./SkipDayWarningModal";
import { normalizeDate } from "../../SWR/SkipDays/skipDaysQuery-utils";
const onMonthChange = (skipDaysByMonth, setDaysForCurrentMonth) => (month) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve) => {
        setDaysForCurrentMonth(skipDaysByMonth.find((skipDays) => skipDays.month === moment(month).month()).days);
        resolve();
    });
});
export default function SkipDayCalendar(props) {
    const { allSkipDays, handleUpdateSkipDay, modalText, modalTitle, month, skipDaysByMonth } = props;
    const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);
    const [dayToSkip, setDayToSkip] = useState();
    const [daysForCurrentMonth, setDaysForCurrentMonth] = useState(skipDaysByMonth && skipDaysByMonth[0].days);
    const handleOpenWarningModal = () => {
        setIsWarningModalOpen(!isWarningModalOpen);
    };
    // TODO-MUI: The time-less UTC date has been difficult to work with but these will need to be implemented.
    // * NOTE: The DateCalendar component has a timeZone prop that may solve this issue, but
    // * I didn't have the time to work with it.
    const lastAvailableDays = skipDaysByMonth && skipDaysByMonth[skipDaysByMonth.length - 1].days;
    const minDate = skipDaysByMonth && normalizeDate(skipDaysByMonth[0].days[0].customerDate);
    const maxDate = lastAvailableDays && normalizeDate(lastAvailableDays[lastAvailableDays.length - 1].customerDate);
    const initDate = skipDaysByMonth && skipDaysByMonth[0].days[0].customerDate;
    const referenceDate = !month ? normalizeDate(initDate) : normalizeDate(month.days[0].customerDate);
    return (_jsxs(_Fragment, { children: [_jsx(Card, Object.assign({ sx: { position: "relative" } }, { children: _jsx(CustomSkipDaysDateCalendar, { allSkipDays: allSkipDays, currentMonth: month, daysForCurrentMonth: daysForCurrentMonth, handleOpenWarningModal: handleOpenWarningModal, handleUpdateSkipDay: handleUpdateSkipDay, hideArrows: month ? true : false, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange(skipDaysByMonth, setDaysForCurrentMonth), referenceDate: referenceDate, setDayToSkip: setDayToSkip, timezone: "utc" }) })), _jsx(SkipDaysWarningModal, { isOpen: isWarningModalOpen, modalTitle: modalTitle, modalText: modalText, onClose: handleOpenWarningModal, handleUpdateSkipDay: handleUpdateSkipDay, dayToSkip: dayToSkip })] }));
}
SkipDayCalendar.propTypes = {
    allSkipDays: PropTypes.array,
    handleUpdateSkipDay: PropTypes.func,
    modalText: PropTypes.string,
    modalTitle: PropTypes.string,
    month: PropTypes.object,
    shouldDisableDate: PropTypes.func,
    skipDaysByMonth: PropTypes.array,
};
